<template>
  <div class="py-0 kios-item">
    <v-card flat style="">
      <h4 class="pt-2 ml-2">
        <span style="color:#065694">TRA CỨU THỦ TỤC HÀNH CHÍNH </span>
      </h4>
      <v-layout wrap class="mt-2">
        <v-flex xs12 sm6 md4 class="pl-2 pr-2">
          <v-autocomplete
            box
            :items="govAgencyList"
            v-model="govAgencySelected"
            label="Cơ quan"
            item-text="administrationName"
            item-value="administrationCode"
            :hide-selected="true"
            @change="changeAdministration"
            color="primary"
            clearable
            height="48"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-2 pr-2">
          <v-autocomplete
            box
            :items="listLinhVuc"
            v-model="linhVucSelected"
            label="Lĩnh vực"
            item-text="domainName"
            item-value="domainCode"
            :hide-selected="true"
            @change="changeDomain"
            color="primary"
            clearable
            height="48"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm12 md4 class="pl-2 pr-2">
          <!-- <v-text-field class="input-border input-search"
            label="Nhập tên thủ tục hành chính"
            v-model="serviceNameKey"
            @keyup.enter="filterServiceinfos('keyword')"
            @click:append="filterServiceinfos('keyword')"
            append-icon="search"
            box
          ></v-text-field> -->
          <div class="input-custom">
            <input id="serviceNameKey" type="text" @focus="show" @keyup.enter="filterServiceinfos('keyword')" required="required" />
            <span class="bar"></span>
            <label for="serviceNameKey">Tên thủ tục hành chính</label>
            <v-icon class="icon-prepend text-bold" size="18" @click="filterServiceinfos('keyword')">search</v-icon>
          </div>
        </v-flex>
      </v-layout>
      <content-placeholders class="mt-3" v-if="loading">
        <content-placeholders-text :lines="10" />
      </content-placeholders>
      <div class="mt-4 ml-1" v-if="!loading && !activeDetailService && !showListThuTuc && govAgencyList && !govAgencySelected && govAgencyList.length > 0" :class="visible ? 'overlayActive': ''">
        <v-layout class="wrap">
          <v-flex xs12 sm4 class="pr-3" v-for="(item, index) in govAgencyList" :key="index">
            <v-btn outline flat color="primary" class="btn-select" @click="filterAdministration(item)" style="width:100%;background-color:#b3d4fc5c!important">{{item.administrationName}}</v-btn>
          </v-flex>
        </v-layout>
      </div>
      <div class="mt-4 pb-2 mx-2" v-if="!loading && !activeDetailService && !showListThuTuc && listLinhVuc && govAgencySelected && !linhVucSelected && listLinhVuc.length > 0" :class="visible ? 'overlayActive': ''">
        <!-- danh sách lĩnh vực -->
        <div class="wrap-scroll wrap-scroll-domain list-domain">
          <v-list class="py-0">
            <template v-for="(item, index) in listLinhVuc" >
              <v-list-tile :key="index" @click="filterDomain(item)">
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.domainName"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </div>
        <div v-if="totalPaggingLinhVuc > 10" class="text-xs-center layout wrap mt-2" style="position: relative;">
          <div class="flex pagging-table px-2"> 
            <tiny-pagination :total="totalPaggingLinhVuc" :page="pageListLinhVuc" custom-class="custom-tiny-class" 
              @tiny:change-page="paggingData" ></tiny-pagination> 
          </div>
        </div>
      </div>
      <!-- danh sách thủ tục -->
      <div class="mt-4" v-if="!loading && !activeDetailService && showListThuTuc" :class="visible ? 'overlayActive': ''">
        <div class="wrap-scroll wrap-scroll-tableservice">
          <v-data-table
            :headers="headersTable"
            :items="listThuTuc"
            hide-actions
            class="table-bordered table-thu-tuc ml-2"
          >
            <template slot="items" slot-scope="props">
              <tr v-bind:class="{'active': props.index%2==1}" @click="viewDetail(props.item)">
                <td class="text-xs-center">
                  <content-placeholders v-if="loading">
                    <content-placeholders-text :lines="1" />
                  </content-placeholders>
                  <div v-else>
                    <span>{{pageListThuTuc * 10 - 10 + props.index + 1}}</span><br>
                  </div>
                </td>
                <td class="text-xs-left" >
                  <content-placeholders v-if="loading">
                    <content-placeholders-text :lines="1" />
                  </content-placeholders>
                  <div v-else>
                    <span>{{props.item.serviceName}}</span>
                  </div>
                </td>
                <td class="text-xs-left">
                  <content-placeholders v-if="loading">
                    <content-placeholders-text :lines="1" />
                  </content-placeholders>
                  <div v-else>
                    <span>
                      <span>{{props.item.domainName}}</span>
                    </span>
                  </div>
                </td>
                <td class="text-xs-center">
                  <content-placeholders v-if="loading">
                    <content-placeholders-text :lines="1" />
                  </content-placeholders>
                  <div v-else>
                    <span>
                      <v-chip class="mx-0 my-0" label :color="getColor(props.item.maxLevel)" text-color="white" style="height:25px">
                        Mức độ {{props.item.maxLevel}}
                      </v-chip>
                      <!-- <span :style="getColor(props.item.maxLevel)">Mức độ {{props.item.maxLevel}}</span> -->
                    </span>
                  </div>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <div class="text-xs-center mt-2">
                Không có thủ tục nào được tìm thấy
              </div>
            </template>
          </v-data-table>
        </div>
        <div v-if="totalPaggingThuTuc > 10" class="text-xs-center layout wrap mt-2" style="position: relative;">
          <div class="flex pagging-table px-2">
            <tiny-pagination :total="totalPaggingThuTuc" :page="pageListThuTuc" custom-class="custom-tiny-class" 
              @tiny:change-page="paggingData" ></tiny-pagination> 
          </div>
        </div>
      </div>
      <!-- chi tiết thủ tục -->
      <div class="mt-4" v-if="!loading && activeDetailService">
        <chi-tiet-thu-tuc :index="serviceId"></chi-tiet-thu-tuc>
      </div>
      <div class="virtual-keyboard" v-if="visible && !isMobile">
        <v-btn small fab color="#383533" @click="visible = false" style="position:absolute;right:0;top:0">
          <v-icon color="#fff">clear</v-icon>
        </v-btn>
        <vue-touch-keyboard v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input" :next="next" :options="options" />
      </div>
      <v-btn v-if="!isMobile" class="back-btn" @click="changeScreen" fab color="primary">
        <v-icon size="20" v-if="!fullScreen" dark>fullscreen</v-icon>
        <v-icon size="20" v-if="fullScreen" dark>fullscreen_exit</v-icon>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import router from '@/router'
import Vue from 'vue/dist/vue.min.js'
import $ from 'jquery'
import TinyPagination from './pagination.vue'
import VueTouchKeyBoard from './keyboard.vue'
import ChiTietThuTuc from './ChiTietThuTuc.vue'
export default {
  props: [],
  components: {
    'tiny-pagination': TinyPagination,
    'vue-touch-keyboard': VueTouchKeyBoard,
    'chi-tiet-thu-tuc': ChiTietThuTuc
  },
  data: () => ({
    loading: false,
    loadingAction: false,
    serviceNameKey: '',
    listLinhVuc: [],
    linhVucSelected: '',
    listMucDo: [],
    levelSelected: '',
    listThuTuc: [],
    govAgencyList: [],
    govAgencySelected: {},
    groupIdSelected: '',
    serviceItemTotal: 0,
    pageListLinhVuc: 1,
    pageListThuTuc: 1,
    totalPaggingLinhVuc: 0,
    totalPaggingThuTuc: 0,
    serviceId: '',
    headersTable: [
      {
        text: 'STT',
        align: 'center',
        sortable: false
      },
      {
        text: 'Tên thủ tục',
        align: 'center',
        sortable: false
      },
      {
        text: 'Lĩnh vực',
        align: 'center',
        sortable: false
      },
      {
        text: 'Mức độ',
        align: 'center',
        sortable: false
      }
    ],
    showListThuTuc: false,
    //
    visible: false,
    layout: 'normal',
    input: null,
    options: {
      useKbEvents: true,
      preventClickEvent: false
    }
  }),
  computed: {
    activeDetailService () {
      return this.$store.getters.getActiveDetailService
    },
    groupIds () {
      return this.$store.getters.getGroupid
    },
    groupIdArr () {
      console.log('groupIds', this.getGroupIdArr(this.groupIds))
      return this.getGroupIdArr(this.groupIds)
    },
    isMobile () {
      return this.$store.getters.getIsMobile
    },
    fullScreen () {
      return this.$store.getters.getFullScreen
    }
  },
  created () {
    let vm = this
    vm.$nextTick(function () {
      var vm = this
      vm.$store.commit('setFullScreen', false)
      let current = vm.$router.history.current
      let newQuery = current.query
      vm.loading = true
      vm.listThuTuc = []
      let groupIds = vm.groupIdArr.length
      if (groupIds > 0) {
        let count = 0
        for (var key = 0; key < groupIds; key++) {
          let filter = {
            groupId: vm.groupIdArr[key]
          }
          vm.$store.dispatch('getGovAgency', filter).then(function (result) {
            count += 1
            result[0] = Object.assign(result[0], {groupId: vm.groupIdArr[key]})
            vm.govAgencyList = vm.govAgencyList.concat(result)
            if (count === groupIds) {
              vm.loading = false
              if (vm.govAgencyList.length > 0) {
                vm.serviceNameKey = newQuery.hasOwnProperty('keyword') ? newQuery.keyword : ''
                vm.levelSelected = newQuery.hasOwnProperty('level') ? Number(newQuery.level) : ''
                vm.linhVucSelected = newQuery.hasOwnProperty('domain') ? newQuery.domain : ''
                vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : ''
                $('#serviceNameKey').val(vm.serviceNameKey)
                if (groupIds === 1) {
                  vm.govAgencySelected = vm.govAgencyList[0]['administrationCode']
                  console.log('govAgencySelected', vm.govAgencySelected)
                }
                vm.filterGovagency()
              }
            }
          }).catch(reject => {
            if (count === groupIds) {
              vm.loading = false
              if (vm.govAgencyList.length > 0) {
                vm.serviceNameKey = newQuery.hasOwnProperty('keyword') ? newQuery.keyword : ''
                vm.levelSelected = newQuery.hasOwnProperty('level') ? Number(newQuery.level) : ''
                vm.linhVucSelected = newQuery.hasOwnProperty('domain') ? newQuery.domain : ''
                vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : ''
                $('#serviceNameKey').val(vm.serviceNameKey)
                if (groupIds === 1) {
                  vm.govAgencySelected = vm.govAgencyList[0]['administrationCode']
                  console.log('govAgencySelected', vm.govAgencySelected)
                }
                vm.filterGovagency()
              }
            }
          })
        }
      } else {
        let filter = {
          groupId: ''
        }
        vm.$store.dispatch('getGovAgency', filter).then(function (result) {
          vm.govAgencyList = result
          vm.loading = false
          if (vm.govAgencyList.length > 0) {
            vm.serviceNameKey = newQuery.hasOwnProperty('keyword') ? newQuery.keyword : ''
            vm.levelSelected = newQuery.hasOwnProperty('level') ? Number(newQuery.level) : ''
            vm.linhVucSelected = newQuery.hasOwnProperty('domain') ? newQuery.domain : ''
            vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : ''
            $('#serviceNameKey').val(vm.serviceNameKey)
            if (vm.govAgencyList.length === 1) {
              vm.govAgencySelected = vm.govAgencyList[0]['administrationCode']
            }
            vm.filterGovagency()
          }
          if (vm.linhVucSelected || vm.serviceNameKey !== '') {
            vm.doLoadingThuTuc()
            vm.showListThuTuc = true
          }
        }).catch(reject => {
          vm.loading = false
        })
      }
    })
  },
  watch: {
    '$route': function (newRoute, oldRoute) {
      let vm = this
      let currentParams = newRoute.params
      let currentQuery = newRoute.query
      vm.govAgencySelected = currentQuery.hasOwnProperty('administration') ? currentQuery.administration : ''
      vm.serviceNameKey = currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : ''
      $('#serviceNameKey').val(vm.serviceNameKey)
      vm.levelSelected = currentQuery.hasOwnProperty('level') ? Number(currentQuery.level) : ''
      vm.linhVucSelected = currentQuery.hasOwnProperty('domain') ? currentQuery.domain : ''
      if (vm.govAgencySelected && !vm.linhVucSelected) {
        vm.loading = true
        let filter = {
          page: currentQuery.page ? currentQuery.page : 1,
          administrationCode: vm.govAgencySelected
        }
        vm.$store.dispatch('getDomainListsPublic', filter).then(function (result) {
          vm.loading = false
          if (result.data) {
            vm.listLinhVuc = result.data
            vm.totalPaggingLinhVuc = Number(result.total)
          } else {
            vm.listLinhVuc = []
            vm.totalPaggingLinhVuc = 0
          }
          vm.pageListLinhVuc = Number(currentQuery.page) ? Number(currentQuery.page) : 1
        }).catch(reject => {
          vm.loading = false
          vm.listLinhVuc = []
          vm.totalPaggingLinhVuc = 0
        })
      }
      if (vm.linhVucSelected || vm.serviceNameKey !== '') {
        vm.doLoadingThuTuc()
        vm.showListThuTuc = true
      }
      if (currentQuery.hasOwnProperty('detail')) {
        vm.$store.commit('setActiveDetailService', true)
      } else {
        vm.$store.commit('setActiveDetailService', false)
      }
    }
  },
  methods: {
    filterServiceinfos (type) {
      var vm = this
      vm.visible = false
      if (type === 'keyword' && vm.serviceNameKey !== '') {
        vm.showListThuTuc = true
      }
      let current = vm.$router.history.current
      let newQuery = current.query
      let queryString = '?'
      if (newQuery.hasOwnProperty('detail')) {
        newQuery['detail'] = ''
      }
      vm.serviceNameKey = $('#serviceNameKey').val()
      newQuery['keyword'] = vm.serviceNameKey
      newQuery['level'] = vm.levelSelected ? vm.levelSelected : ''
      newQuery['domain'] = vm.linhVucSelected ? vm.linhVucSelected : ''
      newQuery['administration'] = vm.govAgencySelected ? vm.govAgencySelected : ''
      newQuery['page'] = 1
      for (let key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
          queryString += key + '=' + newQuery[key] + '&'
        }
      }
      vm.$router.push({
        path: current.path + queryString,
        query: {
          renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
        }
      })
    },
    doLoadingThuTuc () {
      var vm = this
      vm.listThuTuc = []
      vm.loading = true
      let currentQuery = router.history.current.query
      var filter = null
      filter = {
        page: currentQuery.page ? currentQuery.page : 1,
        administration: currentQuery.hasOwnProperty('administration') ? currentQuery.administration : vm.govAgencySelected,
        keyword: currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : '',
        level: currentQuery.hasOwnProperty('level') ? currentQuery.level : vm.levelSelected,
        domain: currentQuery.hasOwnProperty('domain') ? currentQuery.domain : vm.linhVucSelected
      }
      vm.$store.dispatch('getServiceLists', filter).then(function (result) {
        vm.loading = false
        if (result.data) {
          vm.listThuTuc = result.data
          vm.pageListThuTuc = Number(currentQuery.page) ? Number(currentQuery.page) : 1
          vm.totalPaggingThuTuc = result.total
        } else {
          vm.totalPaggingThuTuc = 0
          vm.listThuTuc = []
        }
        vm.serviceItemTotal = result.total
      }).catch(reject => {
        vm.loading = false
        vm.listThuTuc = []
        vm.totalPaggingThuTuc = 0
        vm.serviceItemTotal = 0
      })
    },
    filterGovagency () {
      let vm = this
      let current = vm.$router.history.current
      let newQuery = current.query
      if (vm.govAgencySelected) {
        vm.loading = true
        let filter = {
          page: newQuery.page ? newQuery.page : 1,
          administrationCode: vm.govAgencySelected
        }
        vm.$store.dispatch('getDomainListsPublic', filter).then(function (result) {
          vm.loading = false
          if (result.data) {
            vm.listLinhVuc = result.data
            vm.totalPaggingLinhVuc = Number(result.total)
            if (vm.listLinhVuc.length === 1) {
              vm.linhVucSelected = vm.listLinhVuc[0].domainCode
              vm.changeDomain()
            }
          } else {
            vm.listLinhVuc = []
            vm.totalPaggingLinhVuc = 0
          }
          vm.pageListLinhVuc = Number(newQuery.page) ? Number(newQuery.page) : 1
          if (vm.govAgencySelected && vm.linhVucSelected) {
            vm.doLoadingThuTuc()
          }
        }).catch(reject => {
          vm.listLinhVuc = []
          vm.totalPaggingLinhVuc = 0
          vm.loading = false
        })
      }
    },
    changeAdministration () {
      var vm = this
      console.log('vm.groupIdSelected', vm.govAgencyList, vm.govAgencySelected)
      vm.groupIdSelected = vm.govAgencyList.filter(function (item) {
        return item['administrationCode'] === vm.govAgencySelected
      })[0]['groupId']
      console.log('vm.groupIdSelected', vm.groupIdSelected)
      vm.showListThuTuc = false
      vm.listLinhVuc = []
      vm.linhVucSelected = ''
      vm.levelSelected = ''
      vm.visible = false
      let current = vm.$router.history.current
      let newQuery = {
        administration: ''
      }
      let queryString = '?'
      setTimeout(function () {
        newQuery['administration'] = vm.govAgencySelected ? vm.govAgencySelected : ''
        for (let key in newQuery) {
          if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
            queryString += key + '=' + newQuery[key] + '&'
          }
        }
        vm.$router.push({
          path: current.path + queryString,
          query: {
            renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
          }
        })
      }, 200)
    },
    filterAdministration (item) {
      var vm = this
      vm.govAgencySelected = item.administrationCode
      vm.changeAdministration()
    },
    changeDomain () {
      var vm = this
      vm.showListThuTuc = true
      setTimeout(function () {
        if (vm.linhVucSelected) {
          vm.filterServiceinfos()
        }
      }, 200)
    },
    filterDomain (item) {
      var vm = this
      vm.linhVucSelected = item.domainCode
      vm.changeDomain()
    },
    changeLevel () {
      var vm = this
      setTimeout(function () {
        vm.filterServiceinfos()
      }, 200)
    },
    viewDetail (item) {
      var vm = this
      vm.serviceId = item.serviceInfoId
      let current = vm.$router.history.current
      let newQuery = current.query
      let queryString = '?'
      if (newQuery.hasOwnProperty('detail')) {
        newQuery['detail'] = ''
      }
      for (let key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
          queryString += key + '=' + newQuery[key] + '&'
        }
      }
      queryString += '&detail=true'
      vm.$router.push({
        path: current.path + queryString
      })
    },
    getGroupIdArr (groupIds) {
      if (groupIds) {
        return groupIds.split(',')
      } else {
        return []
      }
    },
    paggingData (config) {
      let vm = this
      let current = vm.$router.history.current
      let newQuery = current.query
      let queryString = '?'
      newQuery['page'] = ''
      // console.log('queryString=====', queryString)
      for (let key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null && newQuery[key] !== 'null') {
          queryString += key + '=' + newQuery[key] + '&'
        }
      }
      queryString += 'page=' + config.page
      vm.$router.push({
        path: current.path + queryString
      })
    },
    getColor (level) {
      if (level === 2) {
        return 'green'
      } else if (level === 3) {
        return 'orange darken-1'
      } else if (level === 4) {
        return 'red'
      }
    },
    govAgencyName (arg) {
      var vm = this
      if (arg) {
        let value = vm.govAgencyList.filter(function (item) {
          return item.administrationCode.toString() === arg.toString()
        })
        if (value.length > 0) {
          return value[0].administrationName
        }
      } else {
        return ''
      }
    },
    changeScreen () {
      var vm = this
      vm.$store.commit('setFullScreen', !vm.fullScreen)
    },
    //
    show (e) {
      this.validPass = true
      this.input = e.target
      if (!this.visible) {
        this.visible = true
      }
      this.bindClick('search')
    },
    bindClick (type) {
      var vm = this
      setTimeout(function () {
        $('.keyboard .enter').unbind('click')
        if (type === 'search') {
          $('.keyboard .enter').bind('click', function () {
            vm.filterServiceinfos('keyword')
          })
        } else if (type === 'view') {
          $('.keyboard .enter').bind('click', function () {
            vm.submitViewDetail()
          })
        }
      }, 300)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TraCuuThuTuc.vue?20801890